module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 19
// module chunks = 0